// Generated by scripts/sync-l10n.mjs. Do not edit by hand.
import ar from './locales/ar.json';
import bg from './locales/bg.json';
import cs from './locales/cs.json';
import da from './locales/da.json';
import de from './locales/de.json';
import el from './locales/el.json';
import en from './locales/en.json';
import es from './locales/es.json';
import et from './locales/et.json';
import fi from './locales/fi.json';
import fr from './locales/fr.json';
import he from './locales/he.json';
import hr from './locales/hr.json';
import hu from './locales/hu.json';
import id from './locales/id.json';
import it from './locales/it.json';
import ja from './locales/ja.json';
import ko from './locales/ko.json';
import lt from './locales/lt.json';
import lv from './locales/lv.json';
import ms from './locales/ms.json';
import nb from './locales/nb.json';
import nl from './locales/nl.json';
import pl from './locales/pl.json';
import ptBR from './locales/pt-BR.json';
import ptPT from './locales/pt-PT.json';
import ro from './locales/ro.json';
import ru from './locales/ru.json';
import sk from './locales/sk.json';
import sl from './locales/sl.json';
import sr from './locales/sr.json';
import sv from './locales/sv.json';
import th from './locales/th.json';
import tr from './locales/tr.json';
import uk from './locales/uk.json';
import vi from './locales/vi.json';
import zhCN from './locales/zh-CN.json';

export const supportedLocales = ['ar', 'bg', 'cs', 'da', 'de', 'el', 'en', 'es', 'et', 'fi', 'fr', 'he', 'hr', 'hu', 'id', 'it', 'ja', 'ko', 'lt', 'lv', 'ms', 'nb', 'nl', 'pl', 'pt-BR', 'pt-PT', 'ro', 'ru', 'sk', 'sl', 'sr', 'sv', 'th', 'tr', 'uk', 'vi', 'zh-CN'] as const;

export type SupportedLocale = (typeof supportedLocales)[number];

export const resources = {
  'ar': { translation: ar },
  'bg': { translation: bg },
  'cs': { translation: cs },
  'da': { translation: da },
  'de': { translation: de },
  'el': { translation: el },
  'en': { translation: en },
  'es': { translation: es },
  'et': { translation: et },
  'fi': { translation: fi },
  'fr': { translation: fr },
  'he': { translation: he },
  'hr': { translation: hr },
  'hu': { translation: hu },
  'id': { translation: id },
  'it': { translation: it },
  'ja': { translation: ja },
  'ko': { translation: ko },
  'lt': { translation: lt },
  'lv': { translation: lv },
  'ms': { translation: ms },
  'nb': { translation: nb },
  'nl': { translation: nl },
  'pl': { translation: pl },
  'pt-BR': { translation: ptBR },
  'pt-PT': { translation: ptPT },
  'ro': { translation: ro },
  'ru': { translation: ru },
  'sk': { translation: sk },
  'sl': { translation: sl },
  'sr': { translation: sr },
  'sv': { translation: sv },
  'th': { translation: th },
  'tr': { translation: tr },
  'uk': { translation: uk },
  'vi': { translation: vi },
  'zh-CN': { translation: zhCN },
} as const;
